import {BucketImageDocType} from "../../../models/config/BucketImageDocType";
import {Button, Table} from "react-bootstrap";
import {FaTimesCircle} from "react-icons/fa";
import React from "react";

export type BucketConfigTableProps = {
    bucketConfigs?: BucketImageDocType[];
    isPending?: boolean;
    onDelete?: (bucketConfig: BucketImageDocType) => void;
};

export const BucketConfigTable = (props: BucketConfigTableProps) => {
    const { isPending, bucketConfigs, onDelete } = props;
    
    return (
        <div className="tw-overflow-auto">
            <Table
                className="table-bordered align-middle"
                size="sm"
            >
                <thead>
                <tr className="table-active thead-light tw-w-full tw-text-center">
                    <th />
                    <th className="nowrap">Image Doc Type</th>
                    <th className="nowrap">Bucket ID</th>
                </tr>
                </thead>
                <tbody>
                    {isPending ? (
                        <tr>
                            <td colSpan={7}>
                                <div className="tw-flex tw-items-center tw-justify-center">
                                    <div className="spinner-border text-primary tw-my-2" />
                                </div>
                            </td>
                        </tr>
                    ) : (
                        bucketConfigs?.map((bucketConfig) => (
                            <tr key={bucketConfig.bucket_id}>
                                <td className="tw-whitespace-nowrap align-middle">
                                    <Button
                                        size="sm"
                                        variant="outline-danger"
                                        className="tw-ml-1"
                                        onClick={() => onDelete?.(bucketConfig)}
                                    >
                                        <FaTimesCircle />
                                    </Button>
                                </td>
                                <td className="tw-whitespace-nowrap align-middle">
                                    {bucketConfig.image_doc_type}
                                </td>
                                <td className="align-middle">
                                    {bucketConfig.bucket_id}
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>
        </div>
    )
};